<template>
  <div class="address-add-cta">
    <div class="icon-container">
      <div class="icon" />
    </div>
    <div class="title">
      {{ trans('addresses.add_cta.title') }}
    </div>
    <div class="text">
      {{ trans('addresses.add_cta.text') }}
    </div>
    <div class="btn btn--primary" @click="$emit('click')">
      {{ trans('addresses.add_cta.button') }}
    </div>
  </div>
</template>

<script>
import { translationMixin } from '@elements/translation';

export default {
  mixins: [ translationMixin ],
};
</script>
